'use strict';
angular.module('kerp-forms.forms').factory('KR_CA_SCHEMA',
  ['fieldDefinitionService', 'kirkleesCareAssessmentConstants', 'kirkleesCareAssessmentService',
    function (fieldDefinitionService, constants, kirkleesCareAssessmentService) {

      var attendanceAllowances = constants.attendanceAllowance;
      var mobilityAllowances = constants.mobilityAllowance;

    function toTitleMapEntry(level, amount) {
      return {value: level, name: amount.toFixed(2)};
    }

      var addressField = fieldDefinitionService.address;

      function address(options) {
        return angular.extend({
          type: 'object',
          title: 'Address',
          properties: {
            uprn: {
              type: 'string'
            },
            line1: addressField.requiredLine(null, true),
            line2: addressField.requiredLine(null, true),
            line3: addressField.optionalLine(null, true),
            postcode: addressField.postcode()
          },
          required: ['line1', 'line2', 'postcode']
        }, options);
      }

      function titleMap(titlesObj) {
        var titlesList = [];

        angular.forEach(titlesObj, function (label, value) {
          titlesList.push({value: value, name: label});
        });
        return titlesList;
      }

      function frequency(options) {
        return angular.extend({
          type: 'string',
          title: 'Frequency',
          "enum": ["Weekly", "Fortnightly", "4 Weekly", "Monthly", "Annually"],

          // this doesn't work for us, but it does if you try it here on the ASF example page
          // http://schemaform.io/examples/bootstrap-example.html
          "default": "Weekly"
        }, options);
      }

      function customFrequency(options) {
        return frequency({
          enum: options,
        });
      }

      function incomeProperties(options) {
        return angular.extend({
          retirementPension: fieldDefinitionService.number.currencyField({
            title: 'State Retirement Pension'
          }),
          retirementPensionPeriod: customFrequency(["Weekly", "Fortnightly", "4 Weekly", "Annually"]),

          attendanceAllowance: fieldDefinitionService.number.mappedCurrencyField({
              title: 'Weekly Attendance Allowance / DLA Care / PIP Daily Living',
              'enum': [
                'high', 'medium', 'low', 'none'
              ]
            }, {
              type: 'select',
              titleMap: [
                toTitleMapEntry("high", attendanceAllowances.high.amount),
                toTitleMapEntry("medium", attendanceAllowances.medium.amount),
                toTitleMapEntry("low", attendanceAllowances.low.amount),
                {value: 'none', name: '0'}
              ]
            }
          ),

          mobilityAllowance: fieldDefinitionService.number.mappedCurrencyField({
              title: 'Weekly DLA Mobility / PIP Mobility',
              'enum': [
                'high', 'medium', 'low', 'none'
              ]
            }, {
              type: 'select',
              titleMap: [
                toTitleMapEntry("high", mobilityAllowances.high.amount),
                toTitleMapEntry("low", mobilityAllowances.low.amount),
                {value: 'none', name: '0'}
              ]
            }
          ),

          carersAllowance: fieldDefinitionService.number.currencyField({
            title: "Carer’s Allowance"
          }),
          carersAllowancePeriod: customFrequency(["Weekly", "4 Weekly"]),

          incapacityBenefit: fieldDefinitionService.number.currencyField({
            title: "JSA / ESA / Incapacity Benefit / Income Support"
          }),
          incapacityBenefitPeriod: customFrequency(["Weekly", "Fortnightly", "4 Weekly", "Annually"]),

          warPension: fieldDefinitionService.number.currencyField({
            title: "War Widow’s/Widower’s Pension"
          }),
          warPensionPeriod: customFrequency(["Weekly", "Fortnightly", "4 Weekly", "Annually"]),

          warDisablementPension: fieldDefinitionService.number.currencyField({
            title: "War Pension/War Disablement Pension"
          }),
          warDisablementPensionPeriod: customFrequency(["Weekly", "Fortnightly", "4 Weekly", "Annually"]),

          privatePension: fieldDefinitionService.number.currencyField({
            title: 'Private/Works Pension'
          }),
          privatePensionPeriod: frequency(),

          warSpecialPayment: fieldDefinitionService.number.currencyField({
            title: 'War Widow’s/Widower’s Special Payment'
          }),
          warSpecialPaymentPeriod: frequency(),

          childBenefit: fieldDefinitionService.number.currencyField({
            title: 'Child Benefit'
          }),
          childBenefitPeriod: customFrequency(["Weekly", "4 Weekly"]),

          earningsFromPaidEmployment: fieldDefinitionService.number.currencyField({
            title: 'Earnings from paid employment'
          }),
          earningsFromPaidEmploymentPeriod: frequency(),

          otherBenefit: fieldDefinitionService.number.currencyField(
            {title: 'Other Income'},
            {description: 'Any other income or benefits you have not already told us about.'}
          ),
          otherBenefitPeriod: frequency()

        }, options || {});
      }

      var schema = {
        type: 'object',
        properties: {
          clientReference: {
            title: "Client Reference",
            type: 'string'
          },
          person: {
            type: 'object',
            title: 'About you',
            properties: {
              intro: {
                type: 'object',
                title: 'Details',
                properties: {

                  havePartner: fieldDefinitionService.boolean.yesNoSchema({
                    title: 'Do you have a partner?'
                  }),
                  declarePartnerFinances: fieldDefinitionService.boolean.yesNoSchema({
                    title: 'Do you want to declare your partner’s finances?'
                  }),
                  dob: fieldDefinitionService.time.dateOfBirth(),
                  dependentChildrenLivingInProperty: {
                    title: 'How many dependent children are living with you in the property?',
                    type: 'integer',
                    minimum: 0
                  },
                  isEntitledToCarersPremium: fieldDefinitionService.boolean.yesNoSchema({
                    title: "Do you have an underlying entitlement to Carer’s Allowance?"
                  }),
                  ownsProperty: fieldDefinitionService.boolean.yesNoSchema({
                    title: "Do you currently own a property?"
                  }),
                  hasAdditionalProperties: fieldDefinitionService.boolean.yesNoSchema({
                    title: 'Other than your home, do you solely or jointly own any properties or land?'
                  })
                },
                required: [
                  'havePartner',
                  'declarePartnerFinances',
                  'dob',
                  'dependentChildrenLivingInProperty',
                  'isEntitledToCarersPremium',
                  'ownsProperty',
                  'hasAdditionalProperties'
                ]
              },
              details: {
                type: 'object',
                title: 'Details',
                properties: {
                  title: {
                    title: 'Title',
                    type: 'string'
                  },
                  firstName: {
                    title: 'First name(s)',
                    type: 'string'
                  },
                  lastName: {
                    title: 'Last name',
                    type: 'string'
                  },
                  nationalInsuranceNumber: fieldDefinitionService.NINO.fullNumber({
                    title: 'National insurance number'
                  }),
                  address: address(),
                  phoneNumber: fieldDefinitionService.phone.localNumber({
                    title: 'Phone number'
                  }),
                  email: fieldDefinitionService.string.email({
                    title: 'Email address'
                  })
                },
                required: ['firstName', 'lastName', 'nationalInsuranceNumber', 'address', 'phoneNumber', 'propertyTenancyDetails']
              },
              capital: {
                type: 'object',
                title: 'Capital',
                properties: {
                  joint: fieldDefinitionService.number.currencyField({
                    title: 'Jointly held capital'
                  }),
                  individual: fieldDefinitionService.number.currencyField({
                    title: 'Individual capital'
                  })
                },
                required: ['individual']
              },
              income: {
                type: 'object',
                title: 'Income',
                properties: incomeProperties({
                  pensionGuaranteeCredit: fieldDefinitionService.number.currencyField({
                    title: 'Total Household Pension Credit (Guarantee Credit)'
                  }),
                  pensionGuaranteeCreditPeriod: customFrequency(["Weekly", "Fortnightly", "4 Weekly", "Annually"]),

                  workingTaxCredit: fieldDefinitionService.number.currencyField({
                    title: 'Total Household Working Tax Credit'
                  }),
                  workingTaxCreditPeriod: customFrequency(["Weekly", "4 Weekly"]),

                  childTaxCredit: fieldDefinitionService.number.currencyField({
                    title: 'Total Household Child Tax Credit'
                  }),
                  childTaxCreditPeriod: customFrequency(["Weekly", "4 Weekly"]),

                  pensionSavingsCredit: fieldDefinitionService.number.currencyField({
                    title: 'Total Household Pension Credit (Savings Credit)'
                  }),
                  pensionSavingsCreditPeriod: customFrequency(["Weekly", "Fortnightly", "4 Weekly", "Annually"]),

                  benefitsPaidAsCouple: fieldDefinitionService.boolean.yesNoSchema({
                    title: "If you receive JSA/ESA, is your partner included in your claim?"
                  }),

                  hasUniversalCredit: fieldDefinitionService.boolean.yesNoSchema(),
                  universalCredit: {
                    type: 'object',
                    properties: {
                      standardAllowance: fieldDefinitionService.number.currencyField({
                        title: 'Standard allowance'
                      }),
                      housingElement: fieldDefinitionService.number.currencyField({
                        title: 'Housing element'
                      }),
                      children: fieldDefinitionService.number.currencyField({
                        title: 'Children'
                      }),
                      disabledChild: fieldDefinitionService.number.currencyField({
                        title: 'Disabled children'
                      }),
                      childcare: fieldDefinitionService.number.currencyField({
                        title: 'Childcare'
                      }),
                      carer: fieldDefinitionService.number.currencyField({
                        title: 'Carer'
                      }),
                      limitedWorkCapability: fieldDefinitionService.number.currencyField({
                        title: 'Limited capability for work'
                      }),
                      limitedWorkAndRelatedCapability: fieldDefinitionService.number.currencyField({
                        title: 'Limited capability for work and work-related activity'
                      }),
                      other: fieldDefinitionService.number.currencyField({
                        title: 'Total taken off for other benefits'
                      }),
                      earnings: fieldDefinitionService.number.currencyField({
                        title: 'Total taken off for take home pay'
                      }),
                      capitalTariff: fieldDefinitionService.number.currencyField({
                        title: 'Total taken off for savings and capital'
                      }),
                      benefitLimit: fieldDefinitionService.number.currencyField({
                        title: 'Total taken off for benefit cap limit'
                      }),
                      advanceRepayments: fieldDefinitionService.number.currencyField({
                        title: 'Total taken off for advance repayments'
                      }),
                      debts: fieldDefinitionService.number.currencyField({
                        title: 'Total taken off for debt and loan repayments'
                      }),
                      landlordPayment: fieldDefinitionService.number.currencyField({
                        title: 'Total taken off for payment to landlord'
                      })
                    },
                    required: [
                      'standardAllowance',
                      'housingElement',
                      'children',
                      'disabledChild',
                      'childcare',
                      'carer',
                      'limitedWorkCapability',
                      'limitedWorkAndRelatedCapability',
                      'other',
                      'earnings',
                      'capitalTariff',
                      'benefitLimit',
                      'advanceRepayments',
                      'debts',
                      'landlordPayment'
                    ]
                  }
                }),

                required: [
                  'retirementPensionPeriod',
                  'incapacityBenefitPeriod',
                  'warPensionPeriod',
                  'warDisablementPensionPeriod',
                  'privatePensionPeriod',
                  'warSpecialPaymentPeriod',
                  'childBenefitPeriod',
                  'earningsFromPaidEmploymentPeriod',
                  'otherBenefitPeriod',

                  // the following are not applicable to partners
                  'workingTaxCreditPeriod',
                  'childTaxCreditPeriod',
                  'pensionGuaranteeCreditPeriod',
                  'pensionSavingsCreditPeriod',
                  'benefitsPaidAsCouple',
                  'hasUniversalCredit',
                  'universalCredit'
                ]
              },
              expenses: {
                type: 'object',
                title: 'Expenses',
                properties: {
                  compulsoryPayments: fieldDefinitionService.number.currencyField({
                    title: 'Court Ordered Payments'
                  }),
                  compulsoryPaymentsPeriod: frequency(),

                  rent: fieldDefinitionService.number.currencyField({
                    title: 'Rent'
                  }),
                  rentPeriod: frequency(),

                  councilTax: fieldDefinitionService.number.currencyField({
                    title: 'Annual Council Tax'
                  }),

                  mortgage: fieldDefinitionService.number.currencyField({
                    title: 'Mortgage'
                  }),
                  mortgagePeriod: frequency()

                },
                required: [
                  // if an amount is entered for an expense, a corresponding frequency/periodicity must be specified
                  'compulsoryPaymentsPeriod',
                  'rentPeriod',
                  'mortgagePeriod'
                ]
              }
            },
            required: ['intro', 'details', 'capital', 'income', 'expenses', 'benefitsAdvice']
          },
          partner: {
            type: 'object',
            title: 'Your partner',
            properties: {
              intro: {
                type: 'object',
                title: 'Details',
                properties: {
                  dob: fieldDefinitionService.time.dateOfBirth()
                },
                required: ['dob']
              },
              capital: {
                type: 'object',
                title: 'Capital',
                properties: {
                  individual: fieldDefinitionService.number.currencyField({
                    title: 'Individual capital'
                  })
                },
                required: ['individual']
              },
              income: {
                type: 'object',
                title: 'Income',
                properties: incomeProperties(),
                required: [
                  'retirementPensionPeriod',
                  'incapacityBenefitPeriod',
                  'warPensionPeriod',
                  'warDisablementPensionPeriod',
                  'privatePensionPeriod',
                  'warSpecialPaymentPeriod',
                  'childBenefitPeriod',
                  'earningsFromPaidEmploymentPeriod',
                  'otherBenefitPeriod'
                ]
              }
            },
            required: ['intro', 'details', 'capital', 'income']
          },
          declaration: {
            type: 'object',
            properties: {
              provideFinancialDetails: {
                title: 'If you would like the Council to assist with the cost of your Carephone package you must fully declare your financial circumstances:',
                type: 'string',
                enum: ['agree', 'arrangeMyOwn'],
                'x-schema-form': {
                  type: "radios",
                  titleMap: titleMap({
                    agree: "I agree to provide my financial details to check whether I may be entitled to help with the cost of a Carephone package.",
                    arrangeMyOwn: "I do not wish to disclose my finances and so agree to pay the full cost of my Carephone package."
                  })
                }
              }
            },
            required: ['provideFinancialDetails']
          },
          careAssessment: {
            type: 'object',
            properties: {
              careDecision: {
                type: "string",
                'enum': ["continue", "continueWithoutFullAssessment", "cancel"]
              },
              carephone: kirkleesCareAssessmentService.careTypeSchema()
            },
            required: [
              'careDecision',
              'carephone'
            ]
          }
        },
        required: ['person', 'careAssessment']
      };

      return {
        getSchema: function () {
          return schema;
        }
      };
    }]);
